import { applicationContainer } from '@/bootstrap/applicationServiceProvider';
import { AUTHENTICATION_SERVICE } from '@/bootstrap/ServiceProviders';

export const useAuthenticationService = () => {
    const service = applicationContainer.get<AuthenticationServiceInterface>(AUTHENTICATION_SERVICE);
    return {
        logout: service.logout,
        hasRole: service.hasRole,
        getUser: service.getUser,
    };

};

export default useAuthenticationService();
